export function getFormattedDate() {
  const date = new Date();
  return date.toISOString().slice(0, 16).replace(/[:]/g, '-');
}

export function formatDuration(duration: number) {
  if (duration < 60000) {
    return `${(duration / 1000).toFixed(2)} seconds`;
  } else if (duration < 3600000) {
    return `${(duration / 60000).toFixed(2)} minutes`;
  } else if (duration < 86400000) {
    return `${(duration / 3600000).toFixed(2)} hours`;
  } else {
    return `${(duration / 86400000).toFixed(2)} days`;
  }
}
